<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="tableWrap"
      rowKey="adNo"
      :columns="columns"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :request-promise="loadList"
      :show-reset-button="true"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="handleCreate">新建</a-button>

      <template v-slot:dateRange="{ record }">
        {{ formatDate(record.startDate) }} 至 {{ formatDate(record.endDate) }}
      </template>

      <template v-slot:statusText="{ record }">
        {{ statusTextMap[record.status] || '-' }}
      </template>

      <template v-slot:updateTime="{ record }">
        {{ formatDateTime(record.updateTime) }}
      </template>

      <template v-slot:action="{ record }">
        <a-space>
          <a
            v-if="Number(record.status) === 0"
            class="status-action"
            @click="handleAdvanceStart(record)"
          >提前开始</a>
          <a
            v-else-if="Number(record.status) === 1"
            class="status-action"
            @click="handleAdvanceEnd(record)"
          >提前结束</a>
          <a
            v-else-if="Number(record.status) === 2"
            class="status-action"
            @click="handleReactivate(record)"
          >重新激活</a>
          <a @click="handleEdit(record)">编辑</a>
        </a-space>
      </template>
    </StandardSearchPageView>
  </div>
</template>

<script>
import moment from 'moment'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

/** 状态：0-未开始 1-进行中 2-已结束 */
const STATUS_TEXT_MAP = {
  0: '未开始',
  1: '进行中',
  2: '已结束'
}

export default {
  name: 'AdvertisementListTab',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      statusTextMap: STATUS_TEXT_MAP,
      queryParams: {
        title: '',
        status: undefined,
        startDate: undefined,
        endDate: undefined
      },
      searchOptions: [
        {
          name: '广告标题',
          key: 'title',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '状态',
          key: 'status',
          type: 'select',
          placeholder: '请选择',
          selectOptions: [
            { label: '未开始', value: 0 },
            { label: '进行中', value: 1 },
            { label: '已结束', value: 2 }
          ]
        },
        {
          name: '投放日期',
          key: 'startDate,endDate',
          type: 'rangePicker'
        }
      ],
      columns: [
        { title: '广告ID', dataIndex: 'adNo', width: 180 },
        { title: '广告标题', dataIndex: 'title', width: 380 },
        {
          title: '投放起止日期',
          dataIndex: 'startDate',
          width: 220,
          scopedSlots: { customRender: 'dateRange' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'statusText' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: 180,
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return '-'
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD') : value
    },
    formatDateTime(value) {
      if (!value) return '-'
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    /**
     * POST /guanggao/list
     * 入参：title/status/startDate/endDate/pageNum/pageSize
     * 出参 data：{ total, pageNum, pageSize, records }
     * CustomPageTable 需要：{ totalCount, pageCount, data }
     */
    loadList(requestParams) {
      const { limitDto, title, status, startDate, endDate } = requestParams
      const pageNum = (limitDto && limitDto.pageNum) || 1
      const pageSize = (limitDto && limitDto.pageSize) || 10

      return this.getHttpServices()
        .getNewServeService()
        .post('/guanggao/list', {
          title: title || '',
          status: status === undefined ? null : status,
          startDate: startDate || '',
          endDate: endDate || '',
          pageNum,
          pageSize
        })
        .then(res => {
          const totalCount = (res && res.total) || 0
          const size = (res && res.pageSize) || pageSize
          return {
            totalCount,
            pageCount: size ? Math.ceil(totalCount / size) : 0,
            data: (res && res.records) || []
          }
        })
    },
    handleCreate() {
      this.$router.push({ name: 'AdvertisementCreate' })
    },
    handleEdit(record) {
      if (!record || !record.adNo) return
      this.$router.push({
        name: 'AdvertisementCreate',
        query: { adNo: record.adNo }
      })
    },
    handleAdvanceStart(record) {
      if (!record || !record.adNo) return
      this.$confirm({
        title: `确定提前开始「${record.title || record.adNo}」吗？`,
        onOk: () => {
          return this.getHttpServices()
            .getNewServeService()
            .post('/guanggao/start', { adNo: record.adNo })
            .then(() => {
              this.$message.success('提前开始成功')
              this.$refs.tableWrap.refresh(false)
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '操作失败，请重试')
            })
        }
      })
    },
    handleAdvanceEnd(record) {
      if (!record || !record.adNo) return
      this.$confirm({
        title: `确定提前结束「${record.title || record.adNo}」吗？`,
        onOk: () => {
          return this.getHttpServices()
            .getNewServeService()
            .post('/guanggao/end', { adNo: record.adNo })
            .then(() => {
              this.$message.success('提前结束成功')
              this.$refs.tableWrap.refresh(false)
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '操作失败，请重试')
            })
        }
      })
    },
    handleReactivate(record) {
      if (!record || !record.adNo) return
      this.$confirm({
        title: `确定重新激活「${record.title || record.adNo}」吗？`,
        onOk: () => {
          return this.getHttpServices()
            .getNewServeService()
            .post('/guanggao/reactivate', { adNo: record.adNo })
            .then(() => {
              this.$message.success('重新激活成功')
              this.$refs.tableWrap.refresh(false)
            })
            .catch(err => {
              this.$message.error((err && err.msg) || '操作失败，请重试')
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.status-action {
  color: #fa8c16;
}
</style>
